/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachmentFileTypeId
 */
export interface AttachmentFileTypeId {
    /**
     * 
     * @type {number}
     * @memberof AttachmentFileTypeId
     */
    fileTypeId: number;
}

export function AttachmentFileTypeIdFromJSON(json: any): AttachmentFileTypeId {
    return AttachmentFileTypeIdFromJSONTyped(json, false);
}

export function AttachmentFileTypeIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentFileTypeId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileTypeId': json['fileTypeId'],
    };
}

export function AttachmentFileTypeIdToJSON(value?: AttachmentFileTypeId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileTypeId': value.fileTypeId,
    };
}


